(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(() => {
  if (window.w4ViewportSizing) return;
  window.w4ViewportSizing = true;
  let frame;
  const update = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const header = document.querySelector('.w4-cargo-header');
      const viewport = window.visualViewport;
      const offset = viewport ? viewport.offsetTop : 0;
      const bottom = offset + (viewport ? viewport.height : window.innerHeight);
      const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
      const top = Math.max(offset, headerBottom);
      const root = document.documentElement;
      if (header) root.style.setProperty('--w4-measured-header-height', `${Math.ceil(header.getBoundingClientRect().height)}px`);
      root.style.setProperty('--w4-drawer-top', `${Math.max(0, top)}px`);
      root.style.setProperty('--w4-drawer-height', `${Math.max(0, bottom - top)}px`);
    });
  };
  const observe = () => {
    const header = document.querySelector('.w4-cargo-header');
    if (header && 'ResizeObserver' in window) new ResizeObserver(update).observe(header);
    update();
  };
  document.addEventListener('shopify:section:load', observe);
  window.addEventListener('resize', update, {passive:true});
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', update, {passive:true});
    window.visualViewport.addEventListener('scroll', update, {passive:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe, {once:true});
  else observe();
})();

  } catch(e) { console.error(e); }
})();
})();
